import { AffiliateSettings } from './affiliate-settings';

export { AffiliateSettings };
